@for (gridItem of grids; track gridItem) {
    @if (gridItem | async; as grid) {
        <ms-grid
            [model]="grid"
            [tracking]="tracking"
            [trackingModuleType]="trackingModuleType"
            [hideTitle]="true"
            [hideMarketSwitcher]="true"
            [showOptionname]="false"
            [showAllWagers]="pod.showAllWagersLink"
            [competitionFallbackIcon]="getSport(grid.sport)"
            [hideFallbackIcon]="true"
            [hideHeaderRegion]="true"
            [hideGroupCount]="true"
            [allowHeaderCollapse]="allowHeaderCollapse" />
    }
}
